module.exports = __webpack_public_path__ + "static/img/14000117.0d31b340.png";